export default __webpack_public_path__ + "static/media/fps.191a3318.png";